import { UnFormalizedZipControllerService } from 'shared/api/generatedApi/services/UnFormalizedZipControllerService';
import { UnFormalizedZipRequestDto, UnFormalizedZipResponseDto } from 'shared/api';

export const unFormalizedZipApi = {
  getUnFormalizedZips: (
    userId?: number,
    status?: UnFormalizedZipResponseDto.status,
  ) => UnFormalizedZipControllerService.findUnFormalizedZips(userId, status),
  getUnFormalizedZipById: (id: number) => UnFormalizedZipControllerService.findUnFormalizedZipById(id),
  createUnFormalizedZip: (data: UnFormalizedZipRequestDto) => UnFormalizedZipControllerService.createUnFormalizedZip(data),
  updateUnFormalizedZip: (id: number, data: UnFormalizedZipRequestDto) => UnFormalizedZipControllerService.updateUnFormalizedZip(id, data),
  deleteUnFormalizedZip: (id: number) => UnFormalizedZipControllerService.deleteUnFormalizedZip(id),
  // Эндпоинта findUnFormalizedZipByDocUrlUuid нет в спецификации; fallback на поиск по id
  getUnFormalizedZipByDocUrlUuid: (docUrlUuid: number) => UnFormalizedZipControllerService.findUnFormalizedZipById(docUrlUuid),
};
